import { useEffect, useState } from "react";
import { useSettings } from "@/lib/useSettings";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Save } from "lucide-react";

function Toggle({ checked, onChange, label, testid }) {
  return (
    <label className="flex items-center gap-2 text-sm text-slate-700 cursor-pointer">
      <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
      {label}
    </label>
  );
}

export default function NotificationsSettings() {
  const { data, save } = useSettings();
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF(data); }, [data]);
  if (!f) return <div className="text-slate-400">Lädt…</div>;

  return (
    <div className="max-w-2xl space-y-6">
      <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4">
        <h2 className="font-display text-lg font-bold text-slate-800">Termin-Benachrichtigungen</h2>
        <p className="text-sm text-slate-500">E-Mail-Benachrichtigung bei neuen Terminzusendungen.</p>
        <Toggle checked={f.notify_enabled} onChange={(v) => setF({ ...f, notify_enabled: v })} label="Benachrichtigungen aktiviert" testid="notify-enabled" />
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Aktiv ab</Label><Input type="date" value={f.notify_from || ""} onChange={(e) => setF({ ...f, notify_from: e.target.value })} className="mt-1" /></div>
          <div><Label>Aktiv bis</Label><Input type="date" value={f.notify_to || ""} onChange={(e) => setF({ ...f, notify_to: e.target.value })} className="mt-1" /></div>
        </div>
        <Button onClick={() => save({ notify_enabled: f.notify_enabled, notify_from: f.notify_from, notify_to: f.notify_to })} className="bg-[#0B132B] hover:bg-[#1C2541]"><Save size={16} className="mr-1.5" /> Speichern</Button>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4">
        <h2 className="font-display text-lg font-bold text-slate-800">Terminerinnerungen</h2>
        <p className="text-sm text-slate-500">Automatische Erinnerungs-E-Mail für bestätigte Termine.</p>
        <Toggle checked={f.reminder_enabled} onChange={(v) => setF({ ...f, reminder_enabled: v })} label="Erinnerungen aktiviert" testid="reminder-enabled" />
        <div><Label>Tage vor dem Termin</Label><Input type="number" min={0} value={f.reminder_days} onChange={(e) => setF({ ...f, reminder_days: Number(e.target.value) })} className="mt-1 w-32" /></div>
        <Button onClick={() => save({ reminder_enabled: f.reminder_enabled, reminder_days: Number(f.reminder_days) || 0 })} className="bg-[#0B132B] hover:bg-[#1C2541]"><Save size={16} className="mr-1.5" /> Speichern</Button>
        <p className="text-xs text-slate-400">Hinweis: Der tatsächliche automatische Versand wird über einen geplanten Task aktiviert (nächster Schritt).</p>
      </div>
    </div>
  );
}
